import { useRef, useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
// Pages
import SessionsCandidate from "./SessionsCandidate";
import SessionCandidate from "./SessionCandidate";
import RequireFail from "../Components/RequireFail";
import Results from "../Components/Sessions/Results";

// import SessionCandidateCopy from "./SessionCandidateCopy";
import NoMatch from "./NoMatch";
import { timeAgo } from "../Components/DateTimeFormatter";
import { fetchUser } from "../Features/Users/Actions/UsersActions";

function removeSessionStorageItems() {
  sessionStorage.removeItem("answers");
  sessionStorage.removeItem("result");
}

export default function Candidate() {
  const [paragraph, setParagraph] = useState("");
  const [title, setTitle] = useState("");

  const { user } = useSelector((store) => store.users);

  const mounted = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    mounted.current = true;
    if (Object.keys(user).length === 0) {
      dispatch(fetchUser());
      return;
    }
    if (mounted.current) {
      if (user?.lastlogin === null || user?.lastlogin === "") {
        setTitle(`Welcome, ${user?.firstname}`);
        setParagraph(`Select your assessement from the list below`);
      } else {
        setTitle(`Welcome back, ${user?.firstname}`);
        setParagraph(`Last logged in ${timeAgo(user?.lastlogin)}.`);
      }
    }
    return () => (mounted.current = false);
  }, [user]);

  useEffect(() => {
    removeSessionStorageItems();
  }, []);

  return (
    <Routes>
      <Route path="/">
        <Route
          path="assessments"
          element={
            <SessionsCandidate
              tabs={[
                // { name: "Today's assessments", value: "1" },
                { name: "My assessments", value: 1 },
              ]}
              paragraph={paragraph}
              title={title}
            />
          }
        />
        <Route
          path="assessments/:id"
          element={<SessionCandidate paragraph={paragraph} title={title} />}
        />
        <Route path="results" element={<RequireFail />}>
          <Route path=":id" element={<Results />} />
        </Route>
        <Route path="*" element={<NoMatch />} />
        {/* 
            Using path="*"" means "match anything", so this route
            acts like a catch-all for URLs that we don't have explicit
            routes for.
          */}
        <Route path="*" element={<NoMatch />} />
      </Route>
    </Routes>
  );
}
